import axios from 'axios'
import {
    Message
} from 'element-ui' // 按需引入UI框架提示组件
import { proxyUrl } from "./config";
// 创建 axios 实例
const service = axios.create({
    baseURL: proxyUrl, // 从环境变量读取基础API地址
    timeout: 10000, // 请求超时时间
    // headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded'
    // }
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        // 处理请求错误
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做统一处理
        const res = response.data;
        if (res.code == 1||res.code == 200||res.status == 200) {
            return res
        } else {
            Message.error(res.msg || '请求出错')
            return Promise.reject(new Error(res.msg || 'Error'))
        }
    },
    error => {
        // 处理HTTP错误状态码
        let message = ''
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    message = '身份认证失败，请重新登录'
                    // 跳转登录页
                    break
                case 403:
                    message = '拒绝访问'
                    break
                case 404:
                    message = '资源不存在'
                    break
                default:
                    message = `网络错误 (${error.response.status})`
            }
        } else if (error.message.includes('timeout')) {
            message = '请求超时'
        } else {
            message = '网络连接异常'
        }

        Message.error(message)
        return Promise.reject(error)
    }
)

// 封装通用请求方法
export function request(config) {
    return service(config)
}
// 可选：封装常用方法
export function get(url, params) {
    return service.get(url, params)
}
export function post(url, data) {
    return service.post(url, data)
}